import { apiBaseUrl } from '../../utils/urls';

export function apiUrl(path: string) {
    return apiBaseUrl + path;
}
